import { Component } from "react"

import * as Sentry from "../../../../../lib/Sentry"
import type EstimateValues from "../../../types/params"

interface Props {
  children: React.ReactNode
  values: EstimateValues
}

interface State {
  hasError: boolean
}

export default class ResultErrorBoundary extends Component<Props, State> {
  public override state: State = { hasError: false }

  constructor(props: Props) {
    super(props)
  }

  public override componentDidUpdate(prevProps: Props) {
    const { values } = this.props
    if (values !== prevProps.values) {
      this.setState({ hasError: false })
    }
  }

  public static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  public override componentDidCatch(error: Error) {
    Sentry.captureException(error)
  }

  public override render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <div>
          問題が発生しました。
          <br />
          入力内容をご確認ください
        </div>
      )
    }

    return children
  }
}
